import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

/**
 * 写真一覧のタグ検索ダイアログの表示状態を管理するカスタムフック。
 *
 * @returns {object} ダイアログの状態と制御関数を含むオブジェクト。
 * - `showTagSearchDialog`: ダイアログの表示状態を表す真偽値。
 * - `toggleTagSearchDialog`: ダイアログの表示状態をトグルする関数。
 * - `closeTagSearchDialog`: ダイアログを閉じる関数。
 */
const useTagSearchDialog = () => {
  const dispatch = useDispatch();
  const [showTagSearchDialog, setShowTagSearchDialog] = useState(false);

  const toggleTagSearchDialog = useCallback(() => {
    setShowTagSearchDialog(prev => {
      if (prev) {
        dispatch({ type: 'CLOSE_TIMELINE_TAG_SEARCH_DIALOG' });
      }
      return !prev;
    });
  }, [dispatch]);

  const closeTagSearchDialog = useCallback(() => {
    setShowTagSearchDialog(false);
    dispatch({ type: 'CLOSE_TIMELINE_TAG_SEARCH_DIALOG' });
  }, [dispatch]);

  return {
    showTagSearchDialog,
    toggleTagSearchDialog,
    closeTagSearchDialog,
  };
};

export default useTagSearchDialog;
